import React, { useEffect } from 'react';
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';

const brands = [
  'ERP CIGE', 'CIGE - ERP', 'CIGE - FI', 'CIGE - CPE', 'CIGE - Planillas', 'Servicios', 'Soluciones TI', 'Microsoft Office', 'Certificado Digital FE', 'Reportes SAP B1'
];

const Banner: React.FC = () => {
  useEffect(() => {
    const glide = new Glide('.glide', {
      type: 'carousel',
      autoplay: 5000,
      perView: 4,
      breakpoints: {
        1200: { perView: 3 },
         800: { perView: 2 },
         600: { perView: 1 }
      }
    });

    glide.mount();

    return () => {
      glide.destroy();
    };
  }, []);

  return (
    <div className="banner glide bg-black-charcoal text-white py-4">
        <div className="max-w-7xl mx-auto">
      <div className="glide__track" data-glide-el="track">

        <ul className="glide__slides">
          {brands.map((brand, index) => (
            <li key={index} className="glide__slide text-center">
              <span className="text-xl font-semibold">{brand}</span>
            </li>
          ))}
        </ul>
        </div>
        </div>
    </div>
  );
};

export default Banner;
